import React from 'react';
import { motion } from 'framer-motion';

export default function Home() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="min-h-[70vh] flex items-center justify-center text-white"
    >
      <div className="flex flex-col items-center px-4">
        <h1 className="text-6xl sm:text-7xl font-extrabold text-accent-blue mb-8 tracking-tight">
          Piggybank
        </h1>
        <p className="font-sans max-w-xl text-center text-xl sm:text-2xl font-normal text-slate-300 leading-relaxed">
          A sincere thank you to everyone who made Piggybank such an amazing journey. We have made the decision to wind down the project. We appreciate every one of you who supported us along the way.
        </p>
      </div>
    </motion.div>
  );
}
